<template>
  <div>
    <el-form ref="form" :rules="rules" :model="form" label-width="50px">
      <br>
      <el-form-item prop="LoginEmail">
        <span slot="label">
          <b-icon name="Username"></b-icon>
        </span>
        <el-input
          type="email"
          autocapitalize="off"
          autocorrect="off"
          v-model="form.LoginEmail"
          placeholder="Email"
        />
      </el-form-item>
      <el-form-item prop="ConfirmEmail">
        <span slot="label">
          <b-icon name="Username"></b-icon>
        </span>
        <el-input
          type="email"
          autocapitalize="off"
          autocorrect="off"
          v-model="form.ConfirmEmail"
          placeholder="Confirm Email"
        />
      </el-form-item>
      <el-form-item prop="Password">
        <span slot="label">
          <b-icon name="Password"></b-icon>
        </span>
        <el-input
          v-model="form.Password"
          placeholder="Password"
          type="password"
          :auto-complete="'off'"
        />
      </el-form-item>
      <el-form-item required>
        <span slot="label">
          <b-icon name="Name"></b-icon>
        </span>
        <el-col :span="12">
          <el-form-item prop="FirstName">
            <el-input v-model="form.FirstName" placeholder="First Name"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="LastName">
            <el-input v-model="form.LastName" placeholder="Last Name"/>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item prop="CustomerPhoneNumber">
        <span slot="label">
          <b-icon name="Phone"></b-icon>
        </span>
        <el-input v-model="form.CustomerPhoneNumber" type="tel" placeholder="Phone Number"/>
      </el-form-item>
      <el-checkbox v-model="checked">
        <p>
          I agree to the
          <a
            class="termslink"
            href="https://droplii.com/terms-of-use/"
            target="_blank"
          >
            Privacy Policy
            & Terms of Use
          </a>
        </p>
      </el-checkbox>
    </el-form>
    <el-button type="primary" @click="onSignup('form')">Sign Up</el-button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      checked: false,
      form: {
        LoginEmail: '',
        ConfirmEmail: '',
        Password: '',
        FirstName: '',
        LastName: '',
        CustomerPhoneNumber: '',
        SignupPromoCode: ''
      },
      rules: {
        LoginEmail: [
          { required: true, message: 'Please input email', trigger: 'blur' }
        ],
        ConfirmEmail: [
          { required: true, message: 'Please confirm email', trigger: 'blur' }
        ],
        Password: [
          { required: true, message: 'Please input password', trigger: 'blur' }
        ],
        FirstName: [
          {
            required: true,
            message: 'Please input first name',
            trigger: 'blur'
          }
        ],
        LastName: [
          { required: true, message: 'Please input last name', trigger: 'blur' }
        ],
        CustomerPhoneNumber: [
          {
            required: true,
            message: 'Please input phone number',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    onSignup(formName) {
      this.$refs[formName].validate(valid => {
        if (valid && this.checked) {
          const user = this.form
          this.$emit('signup', user)
        } else if (!valid) {
          this.$alert('Please finish adding signup details.', 'Oh no!', {
            confirmButtonText: 'OK'
          })
          return false
        } else if (!this.checked) {
          this.$alert(
            'Please check "I agree to the Privacy Policy & Terms of Use."',
            'Oh no!',
            {
              confirmButtonText: 'OK'
            }
          )
        }
      })
    }
  }
}
</script>

<style scoped>
.terms {
  font-size: 10px;
  color: grey;
}
</style>
